import { useEffect } from 'react'
import { X } from 'lucide-react'
import { TABS } from './AdminNav'

// Derive the tab-switch key range from TABS so this stays honest as
// tabs are added or removed. The number-key handler in
// AdminDashboard.tsx uses the same source of truth.
const SHORTCUTS = [
  {
    keys: [TABS.length === 1 ? '1' : `1-${TABS.length}`],
    description: 'Switch tabs',
  },
  { keys: ['/'], description: 'Focus search' },
  { keys: ['j', 'k'], description: 'Navigate table rows' },
  { keys: ['r'], description: 'Record Rebook (selected booking)' },
  { keys: ['c'], description: 'Check Price (selected booking)' },
  { keys: ['Esc'], description: 'Close dialog' },
  { keys: ['⌘', 'Enter'], description: 'Confirm rebook' },
  { keys: ['?'], description: 'This help' },
]

export function KeyboardShortcutsOverlay({ onClose }: { onClose: () => void }) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape' || e.key === '?') {
        e.preventDefault()
        onClose()
      }
    }
    document.addEventListener('keydown', handler)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', handler)
      document.body.style.overflow = ''
    }
  }, [onClose])

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white dark:bg-stone-900 rounded-2xl shadow-2xl max-w-sm w-full p-6" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg text-stone-900 dark:text-stone-100">Keyboard Shortcuts</h2>
          <button onClick={onClose} className="p-1 text-stone-400 hover:text-stone-600 dark:hover:text-stone-300">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="space-y-2">
          {SHORTCUTS.map(({ keys, description }) => (
            <div key={description} className="flex items-center justify-between">
              <span className="text-sm text-stone-600 dark:text-stone-400">{description}</span>
              <div className="flex items-center gap-1">
                {keys.map(key => (
                  <kbd key={key} className="px-2 py-0.5 text-xs font-mono bg-stone-100 dark:bg-stone-800 border border-stone-200 dark:border-stone-700 rounded text-stone-700 dark:text-stone-300">
                    {key}
                  </kbd>
                ))}
              </div>
            </div>
          ))}
        </div>
        <p className="text-xs text-stone-400 mt-4">Shortcuts are disabled when typing in input fields.</p>
      </div>
    </div>
  )
}
